import React from "react";
import PropTypes from "prop-types";

/**
 * EmptyState
 * Componente para exibir mensagem elegante quando uma listagem não tem dados.
 * 
 * Exemplo:
 *   <EmptyState 
 *       icon="mdi mdi-account-off-outline" 
 *       title="Nenhum cliente encontrado" 
 *       description="Tente ajustar os filtros ou cadastre um novo cliente."
 *       actionLabel="Novo Cliente"
 *       onAction={() => navigate("/members/new")}
 *   />
 */
const EmptyState = ({
    icon = "mdi mdi-magnify-close",
    title = "Nenhum resultado encontrado",
    description = "",
    actionLabel,
    onAction
}) => {
    return (
        <div className="text-center py-5">
            <div className="mb-3">
                <i
                    className={icon}
                    style={{
                        fontSize: "64px",
                        color: "#adb5bd",
                        opacity: 0.6
                    }}
                ></i>
            </div>
            <h5 className="text-muted fw-normal mb-2">{title}</h5>
            {description && (
                <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
                    {description}
                </p>
            )}
            {actionLabel && onAction && (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={onAction}
                >
                    <i className="mdi mdi-plus me-1"></i>
                    {actionLabel}
                </button>
            )}
        </div>
    );
};

EmptyState.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    actionLabel: PropTypes.string,
    onAction: PropTypes.func
};

export default EmptyState;
